import React, { useState } from "react";
import { Modal, Container, Form, Button, Dropdown } from "react-bootstrap";
const CarrierUploadSelectModal = ({
  carrierData,
  show,
  setShow,
  selectedCarrierIds,
  setSelectedCarrierIds,
  handleCarrierTemplateDownload,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const filteredCarriers = carrierData
    .filter((carrier) =>
      carrier.carrierName.toLowerCase().includes(searchText.toLowerCase()),
    )
    .sort((a, b) => a.carrierName.localeCompare(b.carrierName));
  return (
    <Container>
      <Modal
        centered
        dialogClassName="custom-modal"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        scrollable
        show={show}
        onHide={() => {
          setSelectedCarrierIds([]);
          setSearchText("");
          setShow(false);
        }}
        style={{ minHeight: "80vh" }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Select Carriers to Include</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ minHeight: "400px", maxHeight: "60vh", overflowY: "auto" }}
        >
          <Form.Group>
            <Form.Label>Carriers</Form.Label>
            <Dropdown
              show={dropdownOpen}
              onToggle={() => setDropdownOpen(!dropdownOpen)}
            >
              <Dropdown.Toggle
                variant="outline-secondary"
                id="carrier-multiselect-dropdown"
                style={{ width: "100%", textAlign: "left" }}
              >
                {selectedCarrierIds.length === 0
                  ? "Select carriers..."
                  : carrierData
                      .filter((c) => selectedCarrierIds.includes(c.id))
                      .map((c) => c.carrierName)
                      .join(", ")}
              </Dropdown.Toggle>
              <Dropdown.Menu
                style={{ maxHeight: 300, overflowY: "auto", width: "100%" }}
              >
                <Form.Control
                  type="text"
                  placeholder="Search carriers..."
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                  style={{ margin: "0.5rem" }}
                  autoFocus
                />
                <Form.Check
                  type="checkbox"
                  id="select-all-carriers"
                  label="Select All"
                  style={{ marginLeft: "1rem", marginBottom: "0.5rem" }}
                  checked={
                    filteredCarriers.length > 0 &&
                    filteredCarriers.every((carrier) =>
                      selectedCarrierIds.includes(carrier.id),
                    )
                  }
                  ref={(el) => {
                    if (el) {
                      el.indeterminate =
                        filteredCarriers.some((carrier) =>
                          selectedCarrierIds.includes(carrier.id),
                        ) &&
                        !filteredCarriers.every((carrier) =>
                          selectedCarrierIds.includes(carrier.id),
                        );
                    }
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      // Add all filtered carrier IDs
                      const newIds = [
                        ...new Set([
                          ...selectedCarrierIds,
                          ...filteredCarriers.map((carrier) => carrier.id),
                        ]),
                      ];
                      setSelectedCarrierIds(newIds);
                    } else {
                      // Remove all filtered carrier IDs
                      const newIds = selectedCarrierIds.filter(
                        (id) => !filteredCarriers.map((c) => c.id).includes(id),
                      );
                      setSelectedCarrierIds(newIds);
                    }
                  }}
                />
                {[...carrierData]
                  .filter((carrier) =>
                    carrier.carrierName
                      .toLowerCase()
                      .includes(searchText.toLowerCase()),
                  )
                  .sort((a, b) => a.carrierName.localeCompare(b.carrierName))
                  .map((carrier) => (
                    <Form.Check
                      key={carrier.id}
                      type="checkbox"
                      id={`carrier-checkbox-${carrier.id}`}
                      label={carrier.carrierName}
                      checked={selectedCarrierIds.includes(carrier.id)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedCarrierIds([
                            ...selectedCarrierIds,
                            carrier.id,
                          ]);
                        } else {
                          setSelectedCarrierIds(
                            selectedCarrierIds.filter(
                              (id) => id !== carrier.id,
                            ),
                          );
                        }
                      }}
                      style={{ marginLeft: "1rem", marginRight: "1rem" }}
                    />
                  ))}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setSelectedCarrierIds([]);
              setSearchText("");
              setShow(false);
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              setSelectedCarrierIds([]);
              handleCarrierTemplateDownload();
              setSearchText("");
              setShow(false);
            }}
          >
            Download
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CarrierUploadSelectModal;
